<template>
    <div>
        <el-button type="primary" @click="bairong">百融PDF</el-button>
        <h1>{{ fkinfo.user_name }}</h1>
        <div class="info">
            <span>手机号：{{ fkinfo.user_phone }}</span>
            <span>身份证：{{ fkinfo.user_id_code }}</span>
            <span>用户id: {{ fkinfo.user_id }}</span>
        </div>
        <div class="info">
            <span>身份证号手机号归属地：{{ fkdata.KeyAttribution.cell.province }} {{ fkdata.KeyAttribution.cell.city }} {{ fkdata.KeyAttribution.cell.card_type }}</span>
        </div>
        <!-- <div class="decision">
            <span>最终决定:{{ fkdata.RiskStrategy.Rule.decision }}</span>
            <span>综合评分:{{ fkdata.RiskStrategy.Rule.weight }}</span>
        </div> -->

        <table border="1" style="border-collapse: collapse;" class="bt">
        <tr>
            <td>综合评分</td>
            <td>审核建议</td>
            <td>偿债压力指数</td>
            <td>法院被执行人-高级版</td>
            <td>借贷意向验证1</td>
            <td>借贷风险勘测1</td>
            <td>特殊名单验证</td>
            <td>法院被执行人-限高版</td>
        </tr>
        <tr>
            <th class="yanse2"> {{ fkdata.RiskStrategy.Rule.weight }} 分 </th>
            <th class="yanse3"> {{ fkdata.RiskStrategy.Rule.decision }} </th>
            <th> {{ fkdata.DebtRepayStress.nodebtscore?fkdata.DebtRepayStress.nodebtscore:0 }}%</th>
            <th>  </th>
            <th class="yanse1">  </th>
            <th class="yanse1">  <block v-if="fkdata.Rule.hit_rules"> <div v-for="data in fkdata.Rule.hit_rules.ruleapplyloan_cashon">{{ data.name_rule }}</div> </block>  </th>
            <th>  </th>
            <th>  </th>

          
        </tr>
    </table>
        
        <h3>申请意向-3C租赁</h3>
        <table border="1" style="border-collapse: collapse;">
        <tr>
            <th>按手机号查询,近3天在3C机构申请总次数: <span>{{fkdata.ApplyLoanC.d3?fkdata.ApplyLoanC.d3.cell.allnum:0}}</span> </th>
            <th>按手机号查询,近3天在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.d3?fkdata.ApplyLoanC.d3.cell.night_allnum:0}}</span></th>
            <th>按手机号查询,近3天在3C机构夜间申请机构数:<span>{{fkdata.ApplyLoanC.d3?fkdata.ApplyLoanC.d3.cell.night_orgnum:0}}</span></th>
            <th>按手机号查询,近3天在3C机构申请总机构数:<span>{{fkdata.ApplyLoanC.d3?fkdata.ApplyLoanC.d3.cell.orgnum:0}}</span></th>
            <th>按手机号查询,近3天在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.d3?fkdata.ApplyLoanC.d3.cell.weekend_allnum:0}}</span></th>
            <th>按手机号查询,近3天在3C机构周末申请机构数:<span>{{fkdata.ApplyLoanC.d3?fkdata.ApplyLoanC.d3.cell.weekend_orgnum:0}}</span></th>
        </tr>

        <tr>
            <th>按身份证号查询,近3天在3C机构申请总次数: <span>{{fkdata.ApplyLoanC.d3?fkdata.ApplyLoanC.d3.id.allnum:0}}</span> </th>
            <th>按身份证号查询,近3天在3C机构夜间申请次数:<span>{{fkdata.ApplyLoanC.d3?fkdata.ApplyLoanC.d3.id.night_allnum:0}}</span></th>
            <th>按身份证号查询,近3天在3C机构夜间申请机构数:<span>{{fkdata.ApplyLoanC.d3?fkdata.ApplyLoanC.d3.id.night_orgnum:0}}</span></th>
            <th>按身份证号查询,近3天在3C机构申请总机构数:<span>{{fkdata.ApplyLoanC.d3?fkdata.ApplyLoanC.d3.id.orgnum:0}}</span></th>
            <th>按身份证号查询,近3天在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.d3?fkdata.ApplyLoanC.d3.id.weekend_allnum:0}}</span></th>
            <th>按身份证号查询,近3天在3C机构周末申请机构数:<span>{{fkdata.ApplyLoanC.d3?fkdata.ApplyLoanC.d3.id.weekend_orgnum:0}}</span></th>
        </tr>

        <tr>
            <th>按手机号查询,近7天在3C机构申请总次数: <span>{{fkdata.ApplyLoanC.d7?fkdata.ApplyLoanC.d7.cell.allnum:0}}</span> </th>
            <th>按手机号查询,近7天在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.d7?fkdata.ApplyLoanC.d7.cell.night_allnum:0}}</span></th>
            <th>按手机号查询,近7天在3C机构夜间申请机构数:<span>{{fkdata.ApplyLoanC.d7?fkdata.ApplyLoanC.d7.cell.night_orgnum:0}}</span></th>
            <th>按手机号查询,近7天在3C机构申请总机构数:<span>{{fkdata.ApplyLoanC.d7?fkdata.ApplyLoanC.d7.cell.orgnum:0}}</span></th>
            <th>按手机号查询,近7天在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.d7?fkdata.ApplyLoanC.d7.cell.weekend_allnum:0}}</span></th>
            <th>按手机号查询,近7天在3C机构周末申请机构数:<span>{{fkdata.ApplyLoanC.d7?fkdata.ApplyLoanC.d7.cell.weekend_orgnum:0}}</span></th>
        </tr> 

        <tr>
            <th>按身份证号查询,近7天在3C机构申请总次数: <span>{{fkdata.ApplyLoanC.d7?fkdata.ApplyLoanC.d7.id.allnum:0}}</span> </th>
            <th>按身份证号查询,近7天在3C机构夜间申请次数:<span>{{fkdata.ApplyLoanC.d7?fkdata.ApplyLoanC.d7.id.night_allnum:0}}</span></th>
            <th>按身份证号查询,近7天在3C机构夜间申请机构数:<span>{{fkdata.ApplyLoanC.d7?fkdata.ApplyLoanC.d7.id.night_orgnum:0}}</span></th>
            <th>按身份证号查询,近7天在3C机构申请总机构数:<span>{{fkdata.ApplyLoanC.d7?fkdata.ApplyLoanC.d7.id.orgnum:0}}</span></th>
            <th>按身份证号查询,近7天在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.d7?fkdata.ApplyLoanC.d7.id.weekend_allnum:0}}</span></th>
            <th>按身份证号查询,近7天在3C机构周末申请机构数:<span>{{fkdata.ApplyLoanC.d7?fkdata.ApplyLoanC.d7.id.weekend_orgnum:0}}</span></th>
        </tr>

        <tr>
            <th>按手机号查询,近14天在3C机构申请总次数: <span>{{fkdata.ApplyLoanC.d14?fkdata.ApplyLoanC.d14.cell.allnum:0}}</span> </th>
            <th>按手机号查询,近14天在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.d14?fkdata.ApplyLoanC.d14.cell.night_allnum:0}}</span></th>
            <th>按手机号查询,近14天在3C机构夜间申请机构数:<span>{{fkdata.ApplyLoanC.d14?fkdata.ApplyLoanC.d14.cell.night_orgnum:0}}</span></th>
            <th>按手机号查询,近14天在3C机构申请总机构数:<span>{{fkdata.ApplyLoanC.d14?fkdata.ApplyLoanC.d14.cell.orgnum:0}}</span></th>
            <th>按手机号查询,近14天在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.d14?fkdata.ApplyLoanC.d14.cell.weekend_allnum:0}}</span></th>
            <th>按手机号查询,近14天在3C机构周末申请机构数<span>{{fkdata.ApplyLoanC.d14?fkdata.ApplyLoanC.d14.cell.weekend_orgnum:0}}</span></th>
        </tr>
        
        <tr>
            <th>按身份证号查询,近14天在3C机构申请总次数: <span>{{fkdata.ApplyLoanC.d14?fkdata.ApplyLoanC.d14.id.allnum:0}}</span> </th>
            <th>按身份证号查询,近14天在3C机构夜间申请次数:<span>{{fkdata.ApplyLoanC.d14?fkdata.ApplyLoanC.d14.id.night_allnum:0}}</span></th>
            <th>按身份证号查询,近14天在3C机构夜间申请机构数:<span>{{fkdata.ApplyLoanC.d14?fkdata.ApplyLoanC.d14.id.night_orgnum:0}}</span></th>
            <th>按身份证号查询,近14天在3C机构申请总机构数:<span>{{fkdata.ApplyLoanC.d14?fkdata.ApplyLoanC.d14.id.orgnum:0}}</span></th>
            <th>按身份证号查询,近14天在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.d14?fkdata.ApplyLoanC.d14.id.weekend_allnum:0}}</span></th>
            <th>按身份证号查询,近14天在3C机构周末申请机构数:<span>{{fkdata.ApplyLoanC.d14?fkdata.ApplyLoanC.d14.id.weekend_orgnum:0}}</span></th>
        </tr>

        <tr>
            <th>按手机号查询,近一个月在3C机构申请总次数: <span>{{fkdata.ApplyLoanC.m1?fkdata.ApplyLoanC.m1.cell.allnum:0}}</span> </th>
            <th>按手机号查询,近一个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m1?fkdata.ApplyLoanC.m1.cell.night_allnum:0}}</span></th>
            <th>按手机号查询,近一个月在3C机构夜间申请机构数:<span>{{fkdata.ApplyLoanC.m1?fkdata.ApplyLoanC.m1.cell.night_orgnum:0}}</span></th>
            <th>按手机号查询,近一个月在3C机构申请总机构数:<span>{{fkdata.ApplyLoanC.m1?fkdata.ApplyLoanC.m1.cell.orgnum:0}}</span></th>
            <th>按手机号查询,近一个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m1?fkdata.ApplyLoanC.m1.cell.weekend_allnum:0}}</span></th>
            <th>按手机号查询,近一个月在3C机构周末申请机构数<span> {{fkdata.ApplyLoanC.m1?fkdata.ApplyLoanC.m1.cell.weekend_orgnum:0}}</span></th>
        </tr>

        <tr>
            <th>按身份证号查询,近一个月在3C机构申请总次数: <span>{{fkdata.ApplyLoanC.m1?fkdata.ApplyLoanC.m1.id.allnum:0}}</span> </th>
            <th>按身份证号查询,近一个月在3C机构夜间申请次数:<span>{{fkdata.ApplyLoanC.m1?fkdata.ApplyLoanC.m1.id.night_allnum:0}}</span></th>
            <th>按身份证号查询,近一个月在3C机构夜间申请机构数:<span>{{fkdata.ApplyLoanC.m1?fkdata.ApplyLoanC.m1.id.night_orgnum:0}}</span></th>
            <th>按身份证号查询,近一个月在3C机构申请总机构数:<span>{{fkdata.ApplyLoanC.m1?fkdata.ApplyLoanC.m1.id.orgnum:0}}</span></th>
            <th>按身份证号查询,近一个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m1?fkdata.ApplyLoanC.m1.id.weekend_allnum:0}}</span></th>
            <th>按身份证号查询,近一个月在3C机构周末申请机构数:<span>{{fkdata.ApplyLoanC.m1?fkdata.ApplyLoanC.m1.id.weekend_orgnum:0}}</span></th>
        </tr>

    </table>

    <table border="1" style="border-collapse: collapse;" class="table2">
        <tr>
            <th>按手机号查询,近三个月在3C机构申请总次数: <span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.cell.allnum:0}}</span> </th>
            <th>按手机号查询,近三个月在3C机构平均每月申请次数(有申请月份平均):<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.cell.avg_monnum:0}}</span></th>
            <th>按手机号查询,近三个月在3C机构最大月申请次数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.cell.max_monnum:0}}</span></th>
            <th>按手机号查询,近三个月在3C机构最小月申请次数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.cell.min_monnum:0}}</span></th>
            <th>按手机号查询,近三个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.cell.night_allnum:0}}</span></th>
            <th>按手机号查询,近三个月在3C机构夜间申请机构数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.cell.night_orgnum:0}}</span></th>
            <th>按手机号查询,近三个月在3C机构申请总机构数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.cell.orgnum:0}}</span></th>
            <th>按手机号查询,近三个月在3C机构有申请记录月份数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.cell.tot_mons:0}}</span></th>
            <th>按手机号查询,近三个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.cell.weekend_allnum:0}}</span></th>
            <th>按手机号查询,近三个月在3C机构周末申请机构数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.cell.weekend_orgnum:0}}</span></th>
        </tr>
        <tr>
            <th>按身份证号查询,近三个月在3C机构申请总次数: <span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.id.allnum:0}}</span> </th>
            <th>按身份证号查询,近三个月在3C机构平均每月申请次数(有申请月份平均):<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.id.avg_monnum:0}}</span></th>
            <th>按身份证号查询,近三个月在3C机构最大月申请次数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.id.max_monnum:0}}</span></th>
            <th>按身份证号查询,近三个月在3C机构最小月申请次数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.id.min_monnum:0}}</span></th>
            <th>按身份证号查询,近三个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.id.night_allnum:0}}</span></th>
            <th>按身份证号查询,近三个月在3C机构夜间申请机构数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.id.night_orgnum:0}}</span></th>
            <th>按身份证号查询,近三个月在3C机构申请总机构数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.id.orgnum:0}}</span></th>
            <th>按身份证号查询,近三个月在3C机构有申请记录月份数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.id.tot_mons:0}}</span></th>
            <th>按身份证号查询,近三个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.id.weekend_allnum:0}}</span></th>
            <th>按身份证号查询,近三个月在3C机构周末申请机构数:<span>{{fkdata.ApplyLoanC.m3?fkdata.ApplyLoanC.m3.id.weekend_orgnum:0}}</span></th>
        </tr>

        <tr>
            <th>按手机号查询,近六个月在3C机构申请总次数: <span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.cell.allnum:0}}</span> </th>
            <th>按手机号查询,近六个月在3C机构平均每月申请次数(有申请月份平均):<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.cell.avg_monnum:0}}</span></th>
            <th>按手机号查询,近六个月在3C机构最大月申请次数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.cell.max_monnum:0}}</span></th>
            <th>按手机号查询,近六个月在3C机构最小月申请次数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.cell.min_monnum:0}}</span></th>
            <th>按手机号查询,近六个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.cell.night_allnum:0}}</span></th>
            <th>按手机号查询,近六个月在3C机构夜间申请机构数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.cell.night_orgnum:0}}</span></th>
            <th>按手机号查询,近六个月在3C机构申请总机构数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.cell.orgnum:0}}</span></th>
            <th>按手机号查询,近六个月在3C机构有申请记录月份数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.cell.tot_mons:0}}</span></th>
            <th>按手机号查询,近六个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.cell.weekend_allnum:0}}</span></th>
            <th>按手机号查询,近六个月在3C机构周末申请机构数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.cell.weekend_orgnum:0}}</span></th>
        </tr>
        <tr>
            <th>按身份证号查询,近六个月在3C机构申请总次数: <span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.id.allnum:0}}</span> </th>
            <th>按身份证号查询,近六个月在3C机构平均每月申请次数(有申请月份平均):<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.id.avg_monnum:0}}</span></th>
            <th>按身份证号查询,近六个月在3C机构最大月申请次数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.id.max_monnum:0}}</span></th>
            <th>按身份证号查询,近六个月在3C机构最小月申请次数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.id.min_monnum:0}}</span></th>
            <th>按身份证号查询,近六个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.id.night_allnum:0}}</span></th>
            <th>按身份证号查询,近六个月在3C机构夜间申请机构数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.id.night_orgnum:0}}</span></th>
            <th>按身份证号查询,近六个月在3C机构申请总机构数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.id.orgnum:0}}</span></th>
            <th>按身份证号查询,近六个月在3C机构有申请记录月份数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.id.tot_mons:0}}</span></th>
            <th>按身份证号查询,近六个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.id.weekend_allnum:0}}</span></th>
            <th>按身份证号查询,近六个月在3C机构周末申请机构数:<span>{{fkdata.ApplyLoanC.m6?fkdata.ApplyLoanC.m6.id.weekend_orgnum:0}}</span></th>
        </tr>

        <tr>
            <th>按手机号查询,近十二个月在3C机构申请总次数: <span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.cell.allnum:0}}</span> </th>
            <th>按手机号查询,近十二个月在3C机构平均每月申请次数(有申请月份平均):<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.cell.avg_monnum:0}}</span></th>
            <th>按手机号查询,近十二个月在3C机构最大月申请次数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.cell.max_monnum:0}}</span></th>
            <th>按手机号查询,近十二个月在3C机构最小月申请次数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.cell.min_monnum:0}}</span></th>
            <th>按手机号查询,近十二个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.cell.night_allnum:0}}</span></th>
            <th>按手机号查询,近十二个月在3C机构夜间申请机构数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.cell.night_orgnum:0}}</span></th>
            <th>按手机号查询,近十二个月在3C机构申请总机构数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.cell.orgnum:0}}</span></th>
            <th>按手机号查询,近十二个月在3C机构有申请记录月份数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.cell.tot_mons:0}}</span></th>
            <th>按手机号查询,近十二个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.cell.weekend_allnum:0}}</span></th>
            <th>按手机号查询,近十二个月在3C机构周末申请机构数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.cell.weekend_orgnum:0}}</span></th>
        </tr>
        <tr>
            <th>按身份证号查询,近十二个月在3C机构申请总次数: <span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.id.allnum:0}}</span> </th>
            <th>按身份证号查询,近十二个月在3C机构平均每月申请次数(有申请月份平均):<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.id.avg_monnum:0}}</span></th>
            <th>按身份证号查询,近十二个月在3C机构最大月申请次数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.id.max_monnum:0}}</span></th>
            <th>按身份证号查询,近十二个月在3C机构最小月申请次数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.id.min_monnum:0}}</span></th>
            <th>按身份证号查询,近十二个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.id.night_allnum:0}}</span></th>
            <th>按身份证号查询,近十二个月在3C机构夜间申请机构数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.id.night_orgnum:0}}</span></th>
            <th>按身份证号查询,近十二个月在3C机构申请总机构数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.id.orgnum:0}}</span></th>
            <th>按身份证号查询,近十二个月在3C机构有申请记录月份数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.id.tot_mons:0}}</span></th>
            <th>按身份证号查询,近十二个月在3C机构周末申请次数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.id.weekend_allnum:0}}</span></th>
            <th>按身份证号查询,近十二个月在3C机构周末申请机构数:<span>{{fkdata.ApplyLoanC.m12?fkdata.ApplyLoanC.m12.id.weekend_orgnum:0}}</span></th>
        </tr>
    </table>

    <h3>团伙欺诈排查（通用版）</h3>
    <table border="1" style="border-collapse: collapse;" class="table2">
        <tr>
            <th>查询人欺诈团伙群组规模: <span>{{ fkdata.FraudRelation_g.group_num?fkdata.FraudRelation_g.group_num:0 }}</span> </th>
            <th>查询人欺诈团伙等级: <span>{{ fkdata.FraudRelation_g.list_level?fkdata.FraudRelation_g.list_level:0 }}</span> </th>

        </tr>
    </table>
    </div>
</template>
  
<script>
import FengkongApi from '@/api/fengkong.js';
export default {
    props: ['fkid'],
    data() {
        return {
            fkdata:'',
            fkinfo:''

        }
    },
    created() {
        console.log("query", this.$route.query);
        const id = this.$route.query.id;
        const uid = this.$route.query.uid;
        if (uid) {
            console.log("uid", uid);
            let self = this;
            let Params = { user_id: uid };
            FengkongApi.detailsUser(Params, true)
                .then(data => {
                    self.loading = false;
                    let str = data.data.data.risk_text;
                    console.log("风控", JSON.parse(str));
                    this.fkdata = JSON.parse(str);
                    console.log("是撒",this.fkdata.swift_number)
                    self.swift_number=this.fkdata.swift_number
                    this.fkinfo = data.data.data;
                })
                .catch(error => { });
        } else if(id) {
            console.log("id",id);
            let self = this;
            let Params = { id: id };
            FengkongApi.riskDetail(Params, true)
                .then(data => {
                    self.loading = false;
                    let str = data.data.data.risk_text;
                    console.log("风控", JSON.parse(str));
                    this.fkdata = JSON.parse(str);
                     console.log("是撒",this.fkdata.swift_number)
                    console.log(data.data.data);
                    this.fkinfo = data.data.data;
                })
                .catch(error => { });
        }else{
            console.log("fkid",this.fkid);
            let self = this;
            let Params = { user_id: this.fkid };
            FengkongApi.detailsUser(Params, true)
                .then(data => {
                    self.loading = false;
                    let str = data.data.data.risk_text;
                    console.log("风控", JSON.parse(str));
                    this.fkdata = JSON.parse(str);
                     console.log("是撒",this.fkdata.swift_number)
                    console.log(data.data.data);
                    this.fkinfo = data.data.data;
                })
                .catch(error => { });
        }
       
    },

    methods: {
        bairong(){
            console.log("asdasdsa", this.fkdata.swift_number)
            let swift_number = this.fkdata.swift_number
            let Params = { swift_number: swift_number };
             FengkongApi.pdf(Params, true)
             .then(data => {
                     window.open(data.msg, '_blank');
                })
                .catch(error => { });
            
        }
        


    }

};
</script>
  
<style>
.yanse1{
    color: #158E1C;
}
.yanse2{
    color: #55668D;
    font-size: 20px;
}
.yanse3{
    color: #158E1C;
    font-size: 20px;
}
h1{
    text-align: center;
}
.decision{
    display: flex;
    justify-content:center;
    align-items:center;
    font-size: 20px;
    padding: 5px;
    color: #158E1C;
}
.decision span{
    margin: 0 10px;
}
.info{
    text-align: center;
    display: flex;
    justify-content:center;
    align-items:center;
    margin-top: 5px;
}
.info span{
    margin-left: 10px;
}
table>tr>th {
    padding: 10px;
}
.bt{
    width: 100%;
    margin-bottom: 20px;
}
.bt>tr>td{
    text-align: center;
    height: 50px;
}
.bt>tr>th{
    text-align: center;
}

/* table>tr>th>span {
    color: red;
} */

table{
    margin-top: 10px;
}

.table2 {
    margin-top: 10px;
}
</style>
  


// WEBPACK FOOTER //
// src/views/riskmanagement/risk/details.vue